







import Vue from 'vue';
import DisclaimersAll from './DisclaimersAll.vue';

export default Vue.extend({
	name: 'DisclaimersWrapper',
	props: ['isReady'],
	components: {
		DisclaimersAll
	}
});
